module.exports = __webpack_public_path__ + "img/collect_pic_23.260898df.png";